import type { Site } from '../Site';

export const WomansOwn: Site = {
  id: 'womansown',
  analyticsName: 'womansown',
  selector: '',
  logo: '',
  label: "Woman's Own",
  platform: '',
};
